<div [formGroup]="form">
    <!-- New button start-->
    <div class="form-group">
        <fc-new-item-findcontrol-button [baseId]="baseId" [form]="form" [apFormGroup]="form" [required]="false"
            [disabled]="false" [findControlId]="FindControlIdService.ViewProvider" [singleSelect]="false"
            [(selectedPks)]="selectedProvidersPks" id="{{ baseId }}-provider-findcontrol" controlName="providersUid"
            findControlDisplayName="Find Providers" (dirty)="providersUidControl.markAsDirty()"
            (chipsChange)="onProviderDataPopulate($event)" buttonTitle="+ New"></fc-new-item-findcontrol-button>
    </div>
    <!-- New button end--->

    <!-- Table start -->
    <table class="table emds-table table-striped table-borderless mt-2">
        <thead>
            <tr>
                <th translate>Name</th>
                <th translate class="action-column">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of providersNames; index as i" id="{{ baseId }}-row-{{ i }}">
                <td>
                    <p>{{providersNames[i]}}</p>
                </td>
                <td>
                    <div class="emds icons-container">
                        <a role="button" title="delete" (click)="deleteProviderRow(i)">
                            <mat-icon class="material-icons">delete</mat-icon>
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
    <!-- Table end -->
</div>
